import React, { useState } from "react";
import { useEffect } from "react";
import Eligibility from "../CommonComponents/Eligibility/Index";
import ApprovalChance from "./ApprovalChance";
import CheckCardStatus from "./CheckCardStatus";
import Approval from "./Approval";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Skeleton from "react-loading-skeleton";

const Index = () => {
  const location = useLocation();
  const data = location.state;
  const [loading, setLoading] = useState(false);
  const [eligiblity, setEligiblity] = useState([]);

  const [res, setResponse] = useState([]);

  const EligiblityHandler = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found!");
        return;
      }

      // Convert data to query params instead of FormData
      const params = {
        specificCard: data?.specificCard,
        monthlyemi: data?.monthlyemi?.replace(/[, ]/g, "") || 0,
        annualIncome: data?.annualIncome?.replace(/[, ]/g, "") || 0,
        age: data?.age || 0,
        employmentType: data?.employmenttype,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_URL}/creditCardEligibilty`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params, // Pass params here correctly
        }
      );

      // console.log("response eligibiity ", response);

      setEligiblity(response.data.data.excatCards);
    } catch (error) {
      console.error(
        "Failed to fetch loan estimate:",
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => {
    EligiblityHandler();
  }, []);

  const DetailHandler = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("cibil", data?.cibil);
      formData.append("specified_card", data?.specificCard);
      formData.append("monthly_income", data?.annualIncome);
      formData.append("monthly_emi", data?.monthlyemi);
      formData.append("profession", data?.employmentType);
      formData.append("company", data?.companyName);
      formData.append("age", data?.age);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/creditCardApproval`,
        formData
      );
      setResponse(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error(
        "Failed to fetch loan estimate:",
        error.response?.data || error.message
      );
      setLoading(false);
    } finally {
    }
  };

  useEffect(() => {
    DetailHandler();
  }, []);

  return (
    <>
      {loading ? (
        <Skeleton count={8} style={{ height: 40, marginTop: 20 }} />
      ) : (
        <>
          <Eligibility data={data} />

          {eligiblity !== null ? (
            <ApprovalChance data={{ data, res }} />
          ) : (
            <div className=" p-8" style={{ backgroundColor: "#f8f8f8" }}>
              <div className="mx-auto max-w-3xl">
                <div className="no-data-icon">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#341664"
                    strokeWidth="2"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <path d="M14 2v6h6" />
                    <path d="M12 18v-6" />
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  </svg>
                </div>
                <h3 className="mt-4 text-center text-xl md:text-3xl font-medium text-[#341664]">
                  You're currently not eligible for the {data?.specificCard}.
                  Explore other cards below.
                </h3>
              </div>
            </div>
          )}

          <CheckCardStatus
            data={{
              res,
              monthlyemi: data?.monthlyemi,
              specificCard: data?.specificCard,
            }}
          />

          <Approval />
        </>
      )}
    </>
  );
};

export default Index;
